var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middleStatistics-container"},[_c('DataPresentation',{attrs:{"title":"智能制造累计生产","number":_vm.cumulative}}),_c('div',{staticClass:"today-production"},[_c('DataPresentationSmall',{attrs:{"title":"今日生产","number":_vm.today}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }